// extracted by mini-css-extract-plugin
module.exports = {"submitCol":"Transfer_submitCol__36dLi","rowTables":"Transfer_rowTables__3_VaT","marginTop20":"Transfer_marginTop20__1wcI7","highlight":"Transfer_highlight__1M33W"};